import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import persistState from "redux-localstorage";
// Each Reducer
import clinicianReducer from "./clinicianDucks";
import languageReducer from "./languageDucks";
import recsysReducer from "./recsysDucks";

const rootReducer = combineReducers({
  clinician: clinicianReducer,
  language: languageReducer,
  recsys: recsysReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function generateStore() {
  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk), persistState()));
  return store;
}
